import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-icon-grid',
  templateUrl: './icon-grid.component.html',
  styleUrls: ['./icon-grid.component.scss']
})
export class IconGridComponent implements OnInit {

  @Input() items: any;
  @Input() title: string;
  @Input() teaser: string;

  constructor() {
  }

  ngOnInit(): void {
  }

  isInternalLink(link: string): boolean {
    return !link.startsWith('http');
  }
}
